module.exports = "https://www.gc-pro.gnp.com.mx/5306fddd22abff4ca442f78d9ff68121.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/boton/10.png
// module id = 1013
// module chunks = 0 1